export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-white" id="about">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left: Text */}
          <div className="w-full lg:w-1/2">
            <div className="text-center border-b-2 border-gray-900 pb-6 mb-8">
              <h2
                className="text-3xl md:text-4xl font-extrabold uppercase leading-tight text-gray-900"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Premier Commercial Asphalt Paving in{' '}
                <strong className="text-yellow-500">New Jersey</strong>
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 text-base leading-relaxed">
              <p>
                <strong>NJ Commercial Asphalt Paving delivers complete commercial asphalt paving, parking lot repair, and pavement maintenance solutions across the entire state of New Jersey.</strong>
              </p>
              <p className="hidden md:block">
                We are a Commercial asphalt paving contractor, proudly serving New Jersey. We service the entire state and specialize in large and small projects. Our employees are fast, clean and courteous — ensuring every job site is left in excellent condition.
              </p>
              <p>
                We have immediate availability so when in need of an asphalt paver, please call us at{' '}
                <a href="tel:8566776191" className="text-yellow-600 font-bold hover:underline">
                  (856) 677-6191
                </a>
                . No project is too big or too small — we handle them all with the same level of care, precision, and professionalism.
              </p>

              <h4
                className="hidden md:block text-xl font-bold text-gray-900 mt-6 uppercase"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                New Jersey&apos;s Trusted Commercial Asphalt Contractors for Quality Work That Lasts
              </h4>
              <p className="hidden md:block">
                In New Jersey, our crews are called on to tackle a wide range of surfaces — from busy commercial corridors and large industrial lots to shopping centers, municipalities, and new development zones. Whether we&apos;re resurfacing a large parking lot or installing fresh asphalt for a new construction site, we approach every job with consistency, care, and attention to detail.
              </p>
              <p className="hidden md:block">
                Being based in New Jersey, <strong>NJ Commercial Asphalt Paving</strong> is closely connected to the local community. We understand the climate, traffic volume, and local permitting processes — and we know what your pavement needs to survive them all.
              </p>
              <p className="hidden md:block">
                <strong><em>&quot;New Jersey deserves better than basic. That&apos;s why every NJ Commercial Asphalt project is handled with fast, clean, and courteous service — and we are available immediately.&quot;</em></strong>
              </p>
              <p>
                Ready to make a lasting investment in your pavement?{' '}
                <a href="#contact" className="text-yellow-600 font-semibold hover:underline">
                  Contact NJ Commercial Asphalt Paving
                </a>{' '}
                today for expert commercial paving in New Jersey.
              </p>
            </div>
          </div>

          {/* Right: Video */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <div
              className="w-full max-w-sm rounded-lg overflow-hidden"
              style={{ aspectRatio: '9/16', position: 'relative' }}
            >
              <iframe
                src="https://www.youtube.com/embed/EHpv2ZzeJnE?autoplay=1&mute=1&loop=1&playlist=EHpv2ZzeJnE&controls=0&modestbranding=1&rel=0&start=2&playsinline=1&iv_load_policy=3&disablekb=1"
                title="NJ Commercial Asphalt Paving"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg border-0"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '100%',
                  height: '100%',
                  transform: 'translate(-50%, -50%)',
                  pointerEvents: 'none',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
